import * as types from "./types";
import moment from "moment";
import {getRevDate , get24hoursTime} from '../components/common/helper'
const dt = new Date().toLocaleString();

const initialState = {
    loader: true,
    maploader :true,
    token:{},
    cityList:[],
    fromCity:{},
    tracktype:'Route',
    msg :'',
    filtermsg : '',
    toCity:{},
    tripfromCity:{},
    triptoCity:{},
    stopagefromCity:{},
    stopagetoCity :{},
    status:'All',
    typewise : '',
    masterbusno : '',
    busmapflag :false,
    tab:'line',
    // depDate: moment(
    //     new Date(getRevDate(dt))
    //   ),
    // toDate : null, 

    routedepDate :  null,//moment(new Date(getRevDate(dt))),
    busdepDate : null,//moment(new Date(getRevDate(dt))),
    tripdepDate : null,//moment(new Date(getRevDate(dt))),
    routeretDate : null,//moment(new Date(getRevDate(dt))) ,
    busretDate :null,//moment(new Date(getRevDate(dt))),
    tripretDate : null,//moment(new Date(getRevDate(dt))),
    routefrom:'Ahmedabad',routeto:'Pune',routestatus:'All',tripfrom:'Ahmedabad',tripto:'Pune',tripservice:'All',
    stopagefromDate: moment(
        new Date(getRevDate(dt))
      ),
    stopagetoDate : null, 
    datediff : 0, 
    dateArr : [],
    masterbusDetails : [],
    servicenameDetails : [],
    staticdetails : [],
    routeDetails :[],
    tripmap : '',
    uniqueId : 0,
    headtxt : '',
    otherdetails : [],
    linedetails :[],
    filterservice : [],
    filterstatus : [],
    filtertrip : [],
    filtermasterbus : [],
    selectedfiltertripid :'',
    selectedfilterstatus :'',
    selectedfilterservice :'',
    selectedfiltermbusno : '',
    tripserviceTime :'',
    tripTime :'' ,
    serviceNameDet:'',
    stopageService :[],
    stopageTripId :[],
    defaultService :'',
    cardstatus :'',
    stopShowdata :{},
    gpsid:'',
    mapdata:{},
    latlng:{},
    busid :'',
    entryTime : {start:'', end:''},
};

const data = function(state = initialState, action) {

    switch(action.type) {
        case types.LOADER:
            return {
                ...state,
                loader: action.data
            };
        case types.UPDATE_TOKEN :
            return {
                ...state,
                token:action.token

        };    
        case types.CITY_LIST:
            const cityList = action.data.CityList ? [...action.data.CityList] : [];
            return {
                ...state,
                cityList
            };
        case types.FROM_CITY:
                const fromCity = action.data ? action.data : {};
                return {
                    ...state,
                    fromCity
                };
        case types.TO_CITY:
                const toCity = action.data ? action.data : {};
                    return {
                        ...state,
                        toCity
                    }  
        case types.UPDATE_TRACK_TYPE:
                // console.log(action.data)
                return {
                    ...state,
                    tracktype : action.data
        }             
        case types.TRIP_FROM_CITY:
            const tripfromCity = action.data ? action.data : {};
            return {
                ...state,
                tripfromCity
            };
        case types.TRIP_TO_CITY:
            const triptoCity = action.data ? action.data : {};
                return {
                    ...state,
                    triptoCity
                }
                
        case types.STOPAGE_FROM_CITY:
            const stopagefromCity = action.data ? action.data : {};
            return {
                ...state,
                stopagefromCity
        };
        case types.STOPAGE_TO_CITY:
            const stopagetoCity = action.data ? action.data : {};
                return {
                    ...state,
                    stopagetoCity
        };                        
        case types.DROP:
            return {
                ...state,
                d1: action.d1,
                d2: action.d2,
                d3: action.d3,
                d4: action.d4,
                d5: action.d5,
                d6: action.d6,
                d7: action.d7,
                d8: action.d8,
                d9: action.d9,
            };
        case types.ROUTE_FROM:
            return {
                ...state,
                routefrom : action.item
        };

        case types.ROUTE_TO:
            return {
                ...state,
                routeto : action.item
        };

        case types.ROUTE_STATUS:
            return {
                ...state,
                status: action.item ? action.item :''
        };


        case types.TYPE_WISE:
            return {
                ...state,
                typewise: action.item
        };

        case types.MASTER_BUS_NO:
            return {
                ...state,
                masterbusno: action.item
        };
        case types.TRIP_FROM:
            return {
                ...state,
                tripfrom: action.item
        };

        case types.TRIP_TO:
            return {
                ...state,
                tripto: action.item
        };

        case types.TRIP_SERVICE:
            return {
                ...state,
                tripservice: action.item
        };

        case types.UPDATE_TRIPSERVICE_TIME :
            // console.log("data",action.data)
            return {
                ...state,
                tripserviceTime: action.data
        };

        case types.UPDATE_SERVICENAME_DET :
            // console.log(action.data)
            return {
                ...state,
                serviceNameDet: action.data
        };

        case types.UPDATE_TRIP_TIME :
            return {
                ...state,
                tripTime: action.data
        };

        case types.SET_DEP_DATE:
            return {
                ...state,
                depDate: action.date
        };

        case types.SET_TO_DATE:
            return {
                ...state,
                toDate: action.date
        };

        case types.ROUTE_FROM_CHART_DATE:
            // console.log("modi",action.date)
            return {
                ...state,
                routedepDate: action.date
        };

        case types.ROUTE_TO_CHART_DATE:
            return {
                ...state,
                routeretDate: action.date
        };


        case types.TRIP_FROM_CHART_DATE:
            // console.log("modi",action.date)
            return {
                ...state,
                tripdepDate: action.date
        };

        case types.TRIP_TO_CHART_DATE:
            return {
                ...state,
                tripretDate: action.date
        };

        case types.BUS_FROM_CHART_DATE:
            // console.log("modi",action.date)
            return {
                ...state,
                busdepDate: action.date
        };

        case types.BUS_TO_CHART_DATE:
            return {
                ...state,
                busretDate: action.date
        };

        case types.SET_DATE_ARR:
            return {
                ...state,
                datediff: action.datediff,
                dateArr: [...action.dateArr]
        };

        case types.UPDATE_MASTERBUS_DETAILS:
            const masterbusDetails = action.data ? [...action.data]: []
            return {
                ...state,
                masterbusDetails

        };


        case types.UPDATE_SERVICENAME_DETAILS:
            // console.log(action.data)
            const servicenameDetails = action.data ? [...action.data]: []
            return {
                ...state,
                servicenameDetails

        };

        case types.UPDATE_ROUTE_DETAILS:
            const routeData = parseData(action.data);
            const routeDetails = routeData ? [...routeData]: [];
            return {
                ...state,
                routeDetails

        };

        case types.UPDATE_STATIC_DETAILS:
            const staticData = parseData(action.data);
            const staticdetails = staticData ? [...staticData]: [];
            return {
                ...state,
                staticdetails

        };


        case types.UPDATE_ID:
            return {
                ...state,
                uniqueId : action.uniqueId

        };

        case types.UPDATE_TRIPMAP:
            return {
                ...state,
                tripmap : action.tripmap

        };

        case types.UPDATE_HEAD_TEXT:
            // console.log(action.data1)
            return {
                ...state,
                headtext : action.data + ' - ' + action.data1+' , '+action.data2

        };

        case types.UPDATE_OTHER_DETAILS:
            // console.log(action.data)
            const otherdetails = action.data ? [...action.data]: [];
            return {
                ...state,
                otherdetails

        };

        case types.UPDATE_LINEGRAPH_DETAILS:
            const linedetails = linedata(action.data)
            const data = action.data ? action.data :{};
            const stopShowdata = {'AvgDelay': data.AvgDelay,'AvgSpeed':data.AvgSpeed,'AvgStoppage':data.AvgStoppage,'TotalStops':data.TotalStops,'CoveredDist':data.CoveredDist}
            return {
                ...state,
                linedetails : linedetails,
                stopShowdata: stopShowdata,

        };


        case types.UPDATE_FILTER_SERVICENAME:
            // console.log(action.data)
            const filterservice = action.data ? [...action.data]: [];
            return {
                ...state,
                filterservice

        };

        case types.UPDATE_FILTER_STATUS:
            // console.log(action.data)
            const filterstatus = action.data ? [...action.data]: [];
            return {
                ...state,
                filterstatus

        };

        case types.UPDATE_FILTER_TRIP:
            // console.log(action.data)
            const filtertrip = action.data ? [...action.data]: [];
            return {
                ...state,
                filtertrip

        };


        case types.UPDATE_FILTER_MASTERBUS:
            // console.log(action.data)
            const filtermasterbus = action.data ? [...action.data]: [];
            return {
                ...state,
                filtermasterbus

        };


        case types.SELECTED_FILTER_SERVICENAME:
            return {
                ...state,
                selectedfilterservice : action.data

        };

        case types.SELECTED_FILTER_STATUS:
            return {
                ...state,
                selectedfilterstatus : action.data

        };


        case types.SELECTED_FILTER_TRIPID:
            return {
                ...state,
                selectedfiltertripid : action.data

        };

        case types.SELECTED_FILTER_MBUSNO:
            return {
                ...state,
                selectedfiltermbusno : action.data

        };

        case types.UPDATE_MESSAGE_TEXT:
            return {
                ...state,
                msg : action.msg

        };

        case types.UPDATE_FILTER_MESSAGE:
            // console.log(action.msg)
            return {
                ...state,
                filtermsg : action.msg

        };

        case types.UPDATE_STOPAGE_SERVICE:
            const stopageService = action.param === 'def' ? [...action.data] : setStopageService(action.data);
            // console.log(stopageService)
            return {
                ...state,
                stopageService : stopageService ? stopageService : [] 

        };

        case types.UPDATE_STOPAGE_TRIPID:
            const stopageTripId = action.data ? [...action.data] :[];
            //console.log(stopageService)
            return {
                ...state,
                stopageTripId

        };

        case types.UPDATE_DEFAULT_SERVICE:
            return {
                ...state,
                defaultService:action.data

        };

        case types.UPDATE_BUSMAP_DETAILS :
            return {
                ...state,
                busmapflag:action.data

        };

        case types.UPDATE_CARD_STATUS :
            return {
                ...state,
                cardstatus:action.status

        };

        case types.UPDATE_MAP_LOADER :
            return {
                ...state,
                maploader : action.data
            }

        case types.UPDATE_GPS_ID :
            return {
                ...state,
                gpsid : action.gpsid
            }    
        case types.UPDATE_MAP_KEY :
            return {
                 ...state,
                 mapdata : action.data
        } 
        
        case types.UPDATE_LAT_LNG :
            return {
                 ...state,
                 latlng : action.data
        } 

        case types.UPDATE_BUS_ID :
            return {
                 ...state,
                 busid : action.busid
        } 


        case types.UPDATE_ENTRY_TIME :
            // console.log("reducer",action.time);
            return {
                 ...state,
                 entryTime : action.time
        }
        
        case types.UPDATE_TAB :
            return {
                ...state,
                tab : action.param
            }

        // case types.UPDATE_FILTER_DETAILS :
        //     routeDetails = filterData(routeDetails);
        //     return {
        //         ...state,
        //         routeDetails
        // };




        default:
            return state;
    }
}

const parseData = (data) =>{
   if(data && data.length > 0){
     data.forEach((element, index)=> {
        element['Id'] = `unique_${index}`  
     }); 
     return data;
   } 
   return [];
}

const linedata = (linedata) =>{
  const pickup = linedata && linedata.Pickups ? [...linedata.Pickups] : [];
  const dropoff = linedata && linedata.Dropoffs ? [...linedata.Dropoffs] : [];
  const data = [...pickup ,...dropoff] 
  data.sort((a,b) => new Date(a.PickupTime ?  a.PickupTime : a.DropoffTime) - new Date(b.PickupTime ?  b.PickupTime : b.DropoffTime));
  return data;  
}

const setStopageService = (data) =>{
  const serviceDet = data.map(el =>{
      const dt = el.TripID + ' - '+ el.RouteName + ' - '+get24hoursTime(el.TripStartTime);
      return dt;
  })
  const uniqueArr = [...new Set(serviceDet)];
//   uniqueArr.unshift('All');
  return uniqueArr;

}

export default data;